import { Component } from '@angular/core';

@Component({
  selector: 'lib-user-management-icon',
  standalone: true,
  imports: [],
  templateUrl: './user-management-icon.component.html',
  styleUrl: './user-management-icon.component.css'
})
export class UserManagementIconComponent {

}
